import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import 'react-day-picker/style.css'
import ReactDOM from 'react-dom/client'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

import Zendesk from 'react-zendesk'

import './index.css'

import * as Sentry from "@sentry/react"

import CustomTooltip from './components/organisms/Graphics/components/CustomTooltip/index.tsx'
import { MenuCardModules } from './components/organisms/MenuCardModules/index.tsx'
import { SidebarProvider } from './components/organisms/Sidebar/SideBarContext.tsx'
import { Routes } from './routes/index.tsx'

async function enableMocking() {
  if (import.meta.env.VITE_NODE_ENV === 'production') {
    return
  }

  // Dev normal: sem MSW (menos trabalho na subida; API real). Vitest usa `node.ts`
  // `yarn dev:test` (--mode testing) ou `VITE_ENABLE_MSW=true` ativam o worker
  const useBrowserMsw =
    import.meta.env.MODE === 'testing' || import.meta.env.VITE_ENABLE_MSW === 'true'

  if (!useBrowserMsw) {
    return
  }

  const { workerBrowser } = await import('@tests/mocks/browser.ts')

  return workerBrowser.start({
    onUnhandledRequest: 'bypass',
  })
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  environment: import.meta.env.VITE_ENVIRONMENT,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserTracingIntegration()
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const settings = {
  color: {
    theme: '#F3123C',
  },
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retryDelay: 5 * 1000,
      retry: 1,
    },
  },
})

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <SidebarProvider>
          <CustomTooltip>
            <Routes />
            <ToastContainer />
            <MenuCardModules />
          </CustomTooltip>
        </SidebarProvider>
      </QueryClientProvider>
      <Zendesk
        defer
        zendeskKey={import.meta.env.VITE_ZENDESK_API_KEY as string}
        {...settings}
      />
    </React.StrictMode>,
  )
})
